import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { analytic } from '../../server/firebase';
import FooterBeparking from '../../components/footer/beparking';

const TycGopassPage = () => {
  useEffect(() => {
    analytic.logEvent('page_view', {
      page: 'Términos y condiciones GoPass',
    });
  }, []);

  return (
    <>
      <Container className="mtop-40 mbottom-50">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={9}>
            <h1 className="texto-titulo centrado">
              TÉRMINOS Y CONDICIONES GOPASS
            </h1>

            <article className="tyc-gopass-body mtop-40">
              <h2>1. Objeto de la campaña</h2>
              <p>
                La presente campaña tiene como objetivo otorgar un beneficio de
                bienvenida a los clientes que se registren por primera vez en be
                parking, de acuerdo con los términos y condiciones aquí
                establecidos.
              </p>

              <h2>2. Beneficiarios</h2>
              <p>
                La campaña aplica exclusivamente a clientes que realicen su
                primer registro y afiliación en be parking. Los clientes que ya
                se encuentren registrados o afiliados previamente a be parking,
                no podrán acceder a este beneficio.
              </p>
              <p>
                El beneficio será otorgado únicamente una vez por cliente y
                estará sujeto a la validación del registro en los sistemas de be
                parking.
              </p>

              <h2>3. Beneficio otorgado</h2>
              <p>
                El cliente que cumpla con las condiciones de la campaña recibirá
                un beneficio equivalente a 3 horas de parqueadero, otorgadas
                mediante 3 bonos independientes de 1 hora cada uno.
              </p>
              <p>
                Cada bono de 1 hora podrá ser utilizado de acuerdo con las
                condiciones de operación y uso establecidas por be parking.
              </p>

              <h2>4. Activación de los bonos</h2>
              <p>
                Los 3 bonos serán activados 24 horas después de que el cliente
                haya completado exitosamente su afiliación o registro en be
                parking.
              </p>
              <p>
                La activación estará sujeta a la validación del registro y al
                correcto funcionamiento de la plataforma.
              </p>

              <h2>5. Vigencia de los bonos de bienvenida</h2>
              <p>
                Los 3 bonos de 60 minutos tendrán una vigencia de 2 meses
                contados a partir de su fecha de activación.
              </p>
              <p>
                Una vez cumplido el período de vigencia, los bonos que no hayan
                sido utilizados expirarán automáticamente, sin que haya lugar a
                su reactivación, compensación o sustitución por dinero u otro
                beneficio.
              </p>

              <h2>6. Bonos obtenidos mediante acumulación de puntos</h2>
              <p>
                Los bonos que el cliente obtenga posteriormente mediante la
                acumulación de puntos, de acuerdo con las condiciones del
                programa de beneficios de be parking, tendrán una vigencia de 30
                días contados a partir de su fecha de activación.
              </p>
              <p>
                Estos bonos estarán sujetos a las condiciones específicas
                establecidas para el programa de puntos vigente al momento de su
                obtención.
              </p>

              <h2>7. No transferibilidad y no canje por dinero</h2>
              <p>
                Los bonos otorgados en el marco de esta campaña son de uso
                personal e intransferible. No podrán ser vendidos, cedidos,
                transferidos ni canjeados por dinero en efectivo o por otros
                beneficios, salvo que BeParking establezca expresamente lo
                contrario.
              </p>

              <h2>8. No acumulabilidad con otras promociones</h2>
              <p>
                Los beneficios otorgados mediante esta campaña no serán
                acumulables con otras promociones, descuentos o beneficios,
                salvo que BeParking indique expresamente que pueden combinarse.
              </p>

              <h2>9. Uso de los bonos</h2>
              <p>
                Los bonos estarán sujetos a las condiciones de uso,
                disponibilidad y operación de los estacionamientos y servicios
                vinculados a be parking. El uso de cada bono estará limitado a
                las condiciones informadas en la plataforma al momento de su
                utilización.
              </p>

              <h2>
                10. Condiciones técnicas y funcionamiento de la plataforma
              </h2>
              <p>
                be parking realizará las gestiones necesarias para garantizar el
                correcto funcionamiento de la plataforma y la aplicación de los
                bonos y puntos. Sin embargo, pueden presentarse situaciones
                técnicas derivadas de actualizaciones, cambios de versión,
                mantenimientos, problemas de conectividad a Internet, fallas de
                sistemas de terceros u otras circunstancias tecnológicas, que
                eventualmente generen demoras, errores o inconvenientes en la
                visualización, activación o aplicación de los bonos y/o puntos.
              </p>
              <p>
                En estos casos, be parking realizará las validaciones
                correspondientes para atender la situación de acuerdo con sus
                procedimientos de soporte.
              </p>

              <h2>11. Soporte y atención al cliente</h2>
              <p>
                En caso de presentar inconvenientes con la activación o
                utilización de los bonos, la acumulación o redención de puntos,
                o cualquier otra situación relacionada con la campaña, el
                cliente podrá solicitar asistencia a través del correo
                electrónico:
              </p>
              <p>
                <a href="mailto:beparking@parking.net.co">
                  beparking@parking.net.co
                </a>
              </p>

              <h2>12. Aceptación de los términos y condiciones</h2>
              <p>
                La participación en esta campaña implica que el cliente ha
                leído, comprendido y aceptado los presentes términos y
                condiciones, así como las demás condiciones aplicables al uso de
                la plataforma y al programa de beneficios de be parking.
              </p>
            </article>
          </Col>
        </Row>
      </Container>
      <FooterBeparking />
    </>
  );
};

export default TycGopassPage;
